import React from 'react';
import classNames from 'classnames';

import './price.scss';

const Price: React.FC<{
    price: number;
    color?: 'primary' | 'secondary' | 'red' | 'green' | 'white' | 'text-primary' | 'text-secondary';
    weight?: 400 | 500 | 600 | 700;
    fontSize?: 10 | 12 | 14 | 16 | 18 | 21 | 24;
    crossed?: boolean;
    className?: string;
}> = ({
    price,
    color = '',
    weight = '500',
    fontSize = 16,
    crossed,
    className
}) => {
    const [priceInteger, priceFractional]: string[] = parseFloat(String(price)).toFixed(2).split('.');

    if (!price) {
        return null;
    }

    return (
        <span
            className={classNames({
                'price': true,
                [`price--${color}`]: !!color,
                [`price--fw-${weight}`]: !!weight,
                [`price--fs-${fontSize}`]: !!fontSize,
                'price-crossed': !!crossed,
                [`${className}`]: !!className
            })}
        >
            {priceInteger.replace(/\B(?=(?:\d{3})+(?!\d))/g, ' ')}
            {`,${priceFractional} zł`}
        </span>
    );
};

export default Price;
